<template>
  <mobile-responsive-shell :title="title">
    <div class="mobile-embed-purchase-form">
      <desktop-view />
    </div>
  </mobile-responsive-shell>
</template>

<script>
import MobileResponsiveShell from "../../components/MobileResponsiveShell.vue";
import DesktopView from "@/views/purchases/items/Edit.vue";

export default {
  name: "MobilePurchasesItemsEdit",
  components: {
    MobileResponsiveShell,
    DesktopView,
  },
  data() {
    return {
      title: "Modifier article",
    };
  },
};
</script>

<style scoped>
.mobile-embed-purchase-form ::v-deep .row {
  margin-left: 0;
  margin-right: 0;
}
.mobile-embed-purchase-form ::v-deep [class*="col-"] {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
}
.mobile-embed-purchase-form ::v-deep .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
